export var hasGeneratedContentDecorations = function hasGeneratedContentDecorations(state) {
  return state.modalDecorationSet.find(undefined, undefined, function (spec) {
    return spec.key === 'generatedInlineDecoration' || spec.key === 'generatedNodeDecoration' || spec.key === 'generatedStartWidget' || spec.key === 'generatedEndWidget';
  }).length > 0;
};